import { useEffect } from 'react';

import {
  RbacEnterpriseRoleBindingsInfiniteQueryArgs,
  useRbacEnterpriseRoleBindingsInfiniteQuery,
} from './useRbacEnterpriseRoleBindingsInfiniteQuery';

export const useRbacEnterpriseRoleBindings = ({
  enabled,
  enterpriseId,
  organizationId,
  subjectId,
  shouldTriggerRetry,
}: RbacEnterpriseRoleBindingsInfiniteQueryArgs = {}) => {
  const paginatedResponse = useRbacEnterpriseRoleBindingsInfiniteQuery({
    enabled,
    enterpriseId,
    organizationId,
    subjectId,
    shouldTriggerRetry,
  });

  const { fetchNextPage, hasNextPage, isFetchingNextPage } = paginatedResponse;

  useEffect(() => {
    if (hasNextPage && !isFetchingNextPage) {
      fetchNextPage();
    }
  }, [fetchNextPage, hasNextPage, isFetchingNextPage]);

  return {
    isLoadingRoleBindings:
      paginatedResponse.isLoading || paginatedResponse.hasNextPage,
    isRoleBindingsError: paginatedResponse.isError,
    roleBindingsError: paginatedResponse.error,
    roleBindings: paginatedResponse.hasNextPage ? [] : paginatedResponse.data,
    refetchRoleBindings: paginatedResponse.refetch,
  };
};
